import { Accordion, AccordionTab } from "primereact/accordion";
import { ProgressBar } from "primereact/progressbar";
import { ProgressSpinner } from "primereact/progressspinner";
import { TabPanel, TabView } from "primereact/tabview";
import { Tooltip } from "primereact/tooltip";
import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { AiOutlineDown, AiOutlineUp, AiFillInfoCircle } from "react-icons/ai";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import iconDownload from "../../../assets/img/interna/download.png";
import ButtonZegel from "../../../components/Buttons/ButtonZegel";
import DialogZegel from "../../../components/Dialog/DialogZegel";
import { PrivateRoutes } from "../../../routes/routes";
import { ListarBibliotecasPorCurso } from "../../../services/BibliotecaServices";
import { CertificadoFCursoAdmiNotas } from "../../../services/CertificadosServices";
import { DescargarListaMaterialesUnidad } from "../../../services/MaterialService";
import {
  ActualizarCursoEstado,
  ObtenerCertificadoPersonaCurso,
  SolicitarAmpliacion,
  ObtenerCursosPorUsuario,
} from "../../../services/UsuarioService";
import Avance from "./Avance";
import "./ModulosAcordion.scss";
import useAlumno from "../../../hooks/useAlumno";
import { handleDownloadCertificado, urlToShare } from "../../../helpers/helpers";
import * as constantes from "../../../constants/constantes.js";

function ModulosAcordionProgramaComponent({
  idPrograma,
  listaCursoPrograma,
  listaProgresoLeccionUnidadeCursoPrograma,
  listaUnidadeCursoPrograma,
  listaEvaluacionesUnidadeCursoPrograma,
  listaLeccionUnidadeCursoPrograma,
  Persona,
  curso,
  setListaBiblioteca,
  setcursoActivarSeleccion,
  cursoActivarSeleccion,
  LeccionesPendientesUnidadCurso,
  PersonaProgamaData
}) {
  const navigate = useNavigate();
  const { perfil, configuraciones } = useAlumno();
  const { idPersonaPrograma } = useParams();
  
  // ===== ESTADOS =====
  const [isButtonDisabledMateriales, setButtonDisabledMateriales] = useState(false);
  const [isButtonDisabledCertificado, setButtonDisabledCertificado] = useState(false);
  const [isButtonDisabledNotas, setButtonDisabledNotas] = useState(false);
  const [spinnerMateriales, setspinnerMateriales] = useState(false);
  const [spinnerCertificado, setspinnerCertificado] = useState(false);
  const [spinnerNotas, setspinnerNotas] = useState(false);
  const [showAlert, setShowAlert] = useState(null);
  const [contenidoAlertActivar, setContenidoAlertActivar] = useState(null);
  const [idCursosRepetidos, setIdCursosRepetidos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showErrorMateriales, setShowErrorMateriales] = useState(false);
  const [showAmpliacion, setShowAmpliacion] = useState(false);
  const [IdPersonaCursoSolicitudAmpliacion, setIdPersonaCursoSolicitudAmpliacion] = useState(0);

  const jwt = window.localStorage.getItem("jwt");

  // ===== FIX: Evitar doble llamado con useRef =====
  const hasLoadedCursos = useRef(false);

  useEffect(() => {
    // Si ya cargó o no hay datos, no hacer nada
    if (hasLoadedCursos.current || !listaCursoPrograma || !perfil?.idUsuario) return;

    const cargarCursosRepetidos = async () => {
      try {
        hasLoadedCursos.current = true; // Marcar como cargado
        
        const data = await ObtenerCursosPorUsuario({ jwt, idUsuario: perfil.idUsuario });
        const idCursos = data.map(curso => [curso.idCurso, curso.idPersonaCurso]);
        const idCursosPersonaPrograma = listaCursoPrograma.map(curso => [curso.idCurso, curso.idPersonaCurso]);
        
        const idCursosRepet = [];
        idCursosPersonaPrograma.forEach(element => {
          idCursos?.forEach(elementidCursos => {
            if (elementidCursos[0] === element[0] && elementidCursos[1] < element[1]) {
              idCursosRepet.push(element[0]);
            }
          });
        });
        
        setIdCursosRepetidos(idCursosRepet);
      } catch (error) {
        console.error("Error al cargar cursos:", error);
        hasLoadedCursos.current = false; // Reset en caso de error
      }
    };

    cargarCursosRepetidos();
  }, [listaCursoPrograma, perfil?.idUsuario, jwt]);

  // ===== OPTIMIZACIÓN: Pre-calcular datos por curso (como computed en Vue) =====
  const datosPorCurso = useMemo(() => {
    if (!listaCursoPrograma || !listaUnidadeCursoPrograma) return {};

    return listaCursoPrograma.reduce((acc, curso) => {
      const unidades = listaUnidadeCursoPrograma.filter(u => u.idCurso === curso.idCurso);
      const todasLecciones = [];
      const todasEvaluaciones = [];

      unidades.forEach(unidad => {
        const leccionesUnidad = listaLeccionUnidadeCursoPrograma?.filter(l => l.idUnidad === unidad.idUnidad) || [];
        todasLecciones.push(...leccionesUnidad);
        
        const evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma?.filter(
          e => e.idUnidad === unidad.idUnidad && e.intento === 1
        ) || [];
        todasEvaluaciones.push(...evaluacionesUnidad);
      });

      const progreso = listaProgresoLeccionUnidadeCursoPrograma?.filter(p => p.idCurso === curso.idCurso) || [];
      const sumaProgreso = progreso.reduce((sum, item) => sum + item.PorcentajeAvance, 0);
      
      const porcentajeLecciones = todasLecciones.length > 0 ? sumaProgreso / todasLecciones.length / 2 : 0;
      const porcentajeEvaluaciones = unidades.length > 0 ? (todasEvaluaciones.length * 100) / unidades.length / 2 : 0;

      acc[curso.idCurso] = {
        porcentajeTotal: porcentajeLecciones + porcentajeEvaluaciones,
        unidades,
        lecciones: todasLecciones,
        evaluaciones: todasEvaluaciones,
      };

      return acc;
    }, {});
  }, [
    listaCursoPrograma,
    listaUnidadeCursoPrograma,
    listaLeccionUnidadeCursoPrograma,
    listaEvaluacionesUnidadeCursoPrograma,
    listaProgresoLeccionUnidadeCursoPrograma
  ]);

  // ===== OPTIMIZACIÓN: Pre-calcular datos por unidad =====
  const datosPorUnidad = useMemo(() => {
    if (!listaUnidadeCursoPrograma) return {};

    return listaUnidadeCursoPrograma.reduce((acc, unidad) => {
      const lecciones = listaLeccionUnidadeCursoPrograma?.filter(l => l.idUnidad === unidad.idUnidad) || [];
      const progreso = listaProgresoLeccionUnidadeCursoPrograma?.filter(
        p => p.idCurso === unidad.idCurso && p.idUnidad === unidad.idUnidad
      ) || [];
      const evaluaciones = listaEvaluacionesUnidadeCursoPrograma?.filter(e => e.idUnidad === unidad.idUnidad) || [];

      const sumaProgreso = progreso.reduce((sum, item) => sum + item.PorcentajeAvance, 0);
      const porcentaje = lecciones.length > 0 ? sumaProgreso / lecciones.length : 0;
      const notaMasAlta = evaluaciones.length > 0 ? Math.max(...evaluaciones.map(e => e.nota)) : null;

      acc[unidad.idUnidad] = {
        porcentaje,
        notaMasAlta,
        cantidadIntentos: evaluaciones.length,
        lecciones
      };

      return acc;
    }, {});
  }, [
    listaUnidadeCursoPrograma,
    listaLeccionUnidadeCursoPrograma,
    listaProgresoLeccionUnidadeCursoPrograma,
    listaEvaluacionesUnidadeCursoPrograma
  ]);

  // ===== OPTIMIZACIÓN: Obtener nota mínima con useMemo =====
  const notaMinima = useMemo(() => {
    return parseFloat(configuraciones?.find(z => z.codigo === "NOTA_MINIMA_APROB")?.valor || 13);
  }, [configuraciones]);

  // ===== CALLBACKS OPTIMIZADOS (como methods en Vue) =====
  const handleChangeAccordion = useCallback(async (e) => {
    const idCurso = listaCursoPrograma[e].idCurso;
    try {
      const data = await ListarBibliotecasPorCurso({ jwt, idCurso });
      setListaBiblioteca(data);
    } catch (error) {
      console.error("Error al cargar biblioteca:", error);
    }
  }, [listaCursoPrograma, jwt, setListaBiblioteca]);

  const handleLinkClickCursoBase = useCallback((idCursoPersona) => {
    navigate(`/${PrivateRoutes.HOME}/CursoInterno/${idCursoPersona}/0/0/${idPersonaPrograma}`);
  }, [navigate, idPersonaPrograma]);

  const onDownloadCertificado = useCallback(async (curso) => {
    try {
      navigate(`/${PrivateRoutes.HOME}/ShareCertificate/InternalCourse/${idPrograma}/${idPersonaPrograma}/${curso.idCurso}`, {
        state: { downloading: true }
      });

      const res = await handleDownloadCertificado({
        cursoPersona: listaCursoPrograma,
        curso,
        persona: Persona,
        tipo: "InternalCourse"
      });

      navigate(`/${PrivateRoutes.HOME}/ShareCertificate/InternalCourse/${idPrograma}/${idPersonaPrograma}/${curso.idCurso}`, {
        state: { downloading: false, res }
      });
    } catch (error) {
      toast.error(error, { autoClose: 3000 });
    }
  }, [idPrograma, idPersonaPrograma, listaCursoPrograma, Persona, navigate]);

  const handleDownloadNotas = useCallback(async (idCurso) => {
    const cursoDat = listaCursoPrograma.filter(x => x.idCurso === idCurso);
    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}_${String(currentDate.getMonth() + 1).padStart(2, '0')}_${String(currentDate.getFullYear()).slice(-2)}`;
    const IdPersonaCurso = cursoDat[0].idPersonaCurso;

    try {
      const dataCert = await ObtenerCertificadoPersonaCurso({ jwt, IdPersonaCurso });
      const unidadesDat = listaUnidadeCursoPrograma.filter(x => x.idCurso === idCurso);
      
      const nombrealumno = `${Persona.nombres?.trim() || ''} ${Persona.primerApellido?.trim() || ''} ${Persona.segundoApellido?.trim() || ''}`.trim();
      const nombrecursoprograma = cursoDat[0].curso.nombre;
      const ubicacion = "Lima";
      const codigoSinPrefijo = dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim();
      const fileName = `${Persona.primerApellido.trim()}-${formattedDate.trim()}-DN_${codigoSinPrefijo}`;
      const enlace = `${urlToShare}${fileName}.pdf`;
      const codigo = dataCert.codigoCertificado;
      const enlaceQR = `${constantes.URL_CERTIFICATE}/ValidateCertificateQR?codigo=${dataCert.codigoCertificado}&tipo=2`;

      let promedionotaD = 0;
      const detalle = unidadesDat.map((unidad, j) => {
        const evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(x => x.idUnidad === unidad.idUnidad);
        const notaMasAlta = evaluacionesUnidad.length > 0 ? Math.max(...evaluacionesUnidad.map(e => e.nota)) : 0;
        promedionotaD += notaMasAlta;

        return {
          nombremodulo: unidad.descripcion,
          promedio: notaMasAlta,
          orden: j + 1,
        };
      });

      const promedionota = (promedionotaD / unidadesDat.length).toFixed();
      const jsonData = JSON.stringify({
        nombrealumno,
        nombrecursoprograma,
        ubicacion,
        enlace,
        enlaceQR,
        codigo,
        promedionota,
        detalle,
      });

      const dataCDN = {
        Extension: enlace.split('.').pop(),
        NombreCDN: fileName
      };

      setspinnerNotas(true);
      setButtonDisabledNotas(true);

      const response = { link: enlace, fileName };
      await CertificadoFCursoAdmiNotas({ jwt, jsonData, dataCDN, response });

      setButtonDisabledNotas(false);
      setspinnerNotas(false);
    } catch (error) {
      setspinnerNotas(false);
      toast.error("Error al generar el detalle de notas", { autoClose: 3000 });
      console.error("Error en handleDownloadNotas:", error);
    }
  }, [listaCursoPrograma, listaUnidadeCursoPrograma, listaEvaluacionesUnidadeCursoPrograma, Persona, jwt]);

  const handleDownloadMaterialesCurso = useCallback(async (idCurso) => {
    const listaUnidades = listaUnidadeCursoPrograma.filter(x => x.idCurso === idCurso);
    
    setButtonDisabledMateriales(true);
    setspinnerMateriales(true);

    for (const unidad of listaUnidades) {
      try {
        const data = await DescargarListaMaterialesUnidad({ jwt, idUnidad: unidad.idUnidad });
        const byteCharacters = atob(data);
        const byteNumbers = new Uint8Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const blob = new Blob([byteNumbers], { type: "application/octet-stream" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${unidad.descripcionSEO}_Materiales.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error al descargar materiales:", error);
        toast.error("Error al descargar materiales del curso", { autoClose: 3000 });
      }
    }

    setButtonDisabledMateriales(false);
    setspinnerMateriales(false);
  }, [listaUnidadeCursoPrograma, jwt]);

  const Actualizar = useCallback(() => {
    setLoading(true);
    const { idPersonaCurso, idCurso, finCurso, idUsuario } = listaCursoPrograma[cursoActivarSeleccion];
    const idEstado = 2;
    const jsonCurso = JSON.stringify({ idPersonaCurso, idUsuario, idCurso, finCurso, idEstado }, null, 2);

    ActualizarCursoEstado({ jsonCurso, jwt }).then(() => {
      setTimeout(() => {
        setShowAlert(false);
        navigate(`/${PrivateRoutes.HOME}/CursoInterno/${idPersonaCurso}`);
      }, 3000);
      setLoading(false);
    });
  }, [listaCursoPrograma, cursoActivarSeleccion, jwt, navigate]);

  const solicitaAmpliacion = useCallback(() => {
    if (IdPersonaCursoSolicitudAmpliacion <= 0) return;

    setLoading(true);
    SolicitarAmpliacion({ jwt, id: IdPersonaCursoSolicitudAmpliacion })
      .then(() => {
        setTimeout(() => {
          setLoading(false);
          setShowAmpliacion(false);
          window.location.reload();
        }, 3000);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error al solicitar ampliación", { autoClose: 3000 });
      });
  }, [IdPersonaCursoSolicitudAmpliacion, jwt]);

  // ===== FUNCIONES DE CÁLCULO OPTIMIZADAS =====
  const obtenerPromedioNumerico = useCallback((idCurso) => {
    if (!listaEvaluacionesUnidadeCursoPrograma || !listaUnidadeCursoPrograma) return null;

    const unidades = listaUnidadeCursoPrograma.filter(u => u.idCurso === idCurso);
    if (unidades.length === 0) return null;

    const total = unidades.reduce((sum, unidad) => {
      const evaluaciones = listaEvaluacionesUnidadeCursoPrograma.filter(e => e.idUnidad === unidad.idUnidad);
      if (evaluaciones.length > 0) {
        return sum + Math.max(...evaluaciones.map(e => e.nota));
      }
      return sum;
    }, 0);
    
    return parseFloat((total / unidades.length).toFixed(0));
  }, [listaEvaluacionesUnidadeCursoPrograma, listaUnidadeCursoPrograma]);

  const calcularDiasVigencia = useCallback((fechaAmpliacionCurso, fechaVigencia, fechaVigenciaMembresia) => {
    const fechaActual = new Date();
    const fechaVigenciaMem = new Date(fechaVigenciaMembresia);
    const fechaCalculable = fechaAmpliacionCurso ? new Date(fechaAmpliacionCurso) : new Date(fechaVigencia);
    const fechaCalculableFinal = fechaVigenciaMembresia
      ? (fechaCalculable > fechaVigenciaMem ? fechaVigenciaMem : fechaCalculable)
      : fechaCalculable;
    
    const diferenciaEnMilisegundos = fechaCalculableFinal - fechaActual;
    return Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24)) + 1;
  }, []);

  // ===== COMPONENTES INTERNOS OPTIMIZADOS =====
  const ProgresoProgramaCursoPormedio = useCallback(({ idCurso }) => {
    const datos = datosPorCurso[idCurso];
    return <span>{datos ? datos.porcentajeTotal.toFixed() : '0.00'}</span>;
  }, [datosPorCurso]);

  const ProgresoProgramaCursoPormedioProgressBar = useCallback(({ idCurso, Color = "#FFB62F" }) => {
    const datos = datosPorCurso[idCurso];
    return (
      <ProgressBar
        style={{ height: "8px", borderRadius: 0 }}
        color={Color}
        value={datos?.porcentajeTotal || 0}
      />
    );
  }, [datosPorCurso]);

  const UnidadEvaluacion = useCallback(({ idCurso, idUnidad }) => {
    const datos = datosPorUnidad[idUnidad];
    if (!datos) return <span className="evaluacion_font__size">Evaluación: --</span>;

    const { notaMasAlta, cantidadIntentos, porcentaje } = datos;

    if (notaMasAlta !== null) {
      return (
        <>
          <span className="evaluacion_font__size Evaluacion1">
            Evaluación:{" "}
            <span style={notaMasAlta < notaMinima ? { color: "red" } : { color: "black" }}>
              {notaMasAlta < notaMinima ? (notaMasAlta <= 9 ? "0" + notaMasAlta : notaMasAlta) : notaMasAlta}
            </span>
          </span>
          <Tooltip
            target=".Evaluacion1"
            content="¡Recuerda dar tu evaluación! Te queda un intento"
            className="white-tooltip"
            position="left"
          />
        </>
      );
    }

    return (
      <>
        <span className={
          (porcentaje >= 0 && porcentaje < 100) || (porcentaje === 100 && cantidadIntentos === 0)
            ? "evaluacion_font__size EvaluacionTooltip"
            : "evaluacion_font__size"
        }>
          Evaluación: --
        </span>
        <Tooltip
          target=".EvaluacionTooltip"
          content="¡Recuerda dar tu evaluación! Revisa que hayas completado al menos un intento con nota aprobatoria"
          className="white-tooltip"
          position="left"
        />
      </>
    );
  }, [datosPorUnidad, notaMinima]);

  const ProgresoProgramaCursoUnidadPormedioProgressBar = useCallback(({ idCurso, idUnidad }) => {
    const datos = datosPorUnidad[idUnidad];
    const leccionesPendientes = LeccionesPendientesUnidadCurso?.filter(
      x => x.idUnidad === idUnidad && x.idCurso === idCurso
    )[0]?.leccionesPendientes || [];

    return (
      <>
        <ProgressBar
          className={`ProgressBar${idUnidad}`}
          style={{ height: "8px", borderRadius: 0 }}
          value={datos?.porcentaje.toFixed(2) || 0}
        />
        <Tooltip
          target={`.ProgressBar${idUnidad}`}
          content={
            datos && datos.porcentaje > 0 && datos.porcentaje < 100
              ? `¡Termina tus videos! \nAún no has culminado \nla(s) lección(es): ${leccionesPendientes.join(",")}`
              : ""
          }
          className="white-tooltip"
        />
      </>
    );
  }, [datosPorUnidad, LeccionesPendientesUnidadCurso]);

  const ProgresoProgramaCursoUnidadPormedio = useCallback(({ idCurso, idUnidad }) => {
    const datos = datosPorUnidad[idUnidad];
    return (
      <span className={`ProgressBar${idUnidad}`} style={{ color: "blue" }}>
        {datos ? Math.round(datos.porcentaje) : 0}%
      </span>
    );
  }, [datosPorUnidad]);

  const VistaPromedio = useCallback(({promedio}) => {
    const esNumerico = !isNaN(promedio);
    const promedioNum = parseFloat(promedio);
    const getColor = () => !esNumerico ? "black" : promedioNum < notaMinima ? "red" : "black";    
    return (
      <>
        {esNumerico && (
          <Tooltip
            target=".promedio-tooltip"
            position="top"
            className="white-tooltip"
            content={
              promedioNum < notaMinima
                ? "Recuerda que para obtener tu certificado debes contar con al menos 13 puntos en el promedio"
                : "¡Felicitaciones! Obtuviste una nota aprobatoria."
            }
          />
        )}
        <span className="subtitle h4 promedio-tooltip">
          Promedio total del módulo: 
          <span style={{ color: getColor(), fontWeight: "bold" }}> {promedio}</span>
        </span>
      </>
    );
  }, [notaMinima]);

  const calcularPromedioNotasPorUnidad = useCallback((promedio) => {
    return VistaPromedio(promedio ?? "--");
  }, [VistaPromedio]);

  // ===== CONTENIDOS DE DIÁLOGOS =====
  const contenidoActivar = useMemo(() => (
    <div>
      <span>
        <strong>{"¿Estás seguro de que quieres activar el módulo " + curso?.nombre + "?"}</strong>
      </span>
      <br /><br />
      <span>Recuerda que tienes 30 días para culminar el módulo, una vez comenzado no podrás desactivarlo.</span>
    </div>
  ), [curso]);

  const contenidoAmpliacion = (
    <div>
      <span><strong>{"Recuerda que..."}</strong></span>
      <br /><br />
      <span style={{ fontSize: 12 }}>
        Tienes 14 días más para culminar con el curso. Luego de esta ampliación el curso quedará expirado permanentemente.
      </span>
    </div>
  );

  const contenidoErrorMateriales = (
    <div>
      <span><strong>{"Ocurrió un error al descargar materiales..."}</strong></span>
      <br /><br />
      <span style={{ fontSize: 12 }}>Intenta nuevamente por favor.</span>
    </div>
  );

  // ===== FOOTERS DE DIÁLOGOS =====
  const footerActivar = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel label="Activar módulo" color="primary" onClick={Actualizar} />
      </div>
      <div>
        <ButtonZegel label="Cancelar" color="secondary" onClick={() => setShowAlert(false)} />
      </div>
    </>
  );

  const footerAmpliacion = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel label="Aceptar ampliación" color="primary" onClick={solicitaAmpliacion} loading={loading} />
      </div>
      <div>
        <ButtonZegel label="Cancelar" color="secondary" onClick={() => setShowAmpliacion(false)} />
      </div>
    </>
  );

  const footerErrorMateriales = (
    <div>
      <ButtonZegel label="Cerrar" color="primary" onClick={() => setShowErrorMateriales(false)} />
    </div>
  );

  // ===== ICONOS DEL ACORDEÓN =====
  const NewExpandIcontemplate = <span className="icon-acordeon"><AiOutlineDown /></span>;
  const NewCollapseIcontemplate = <span className="icon-acordeon"><AiOutlineUp /></span>;

  // ===== RENDER =====
  return (
    <div style={{ marginBottom: "30px" }}>
      <div className="p-fluid formgrid grid">
        <div className="field col-12 md:col-12 contenedor_titulo_header">
          <b className="titulo_header">Abre el módulo que deseas ver</b>
        </div>
      </div>

      <Accordion
        activeIndex={0}
        expandIcon={NewExpandIcontemplate}
        collapseIcon={NewCollapseIcontemplate}
        onTabOpen={(e) => handleChangeAccordion(e.index)}
      >
        {listaCursoPrograma?.map((item, i) => {
          const estaRepetido = idCursosRepetidos.includes(item.idCurso);
          const promedioNumerico = obtenerPromedioNumerico(item.idCurso);
          const puedeDescargar =
            item.idEstado === 1 &&
            item.idCondicion !== 2 &&
            isButtonDisabledCertificado === false &&
            listaEvaluacionesUnidadeCursoPrograma &&
            promedioNumerico >= notaMinima;

          const diasVigencia = calcularDiasVigencia(
            item.fechaAmpliacionCurso,
            item.fechaVigencia,
            item.fechaVigenciaMembresia
          );

          return (
            <AccordionTab
              key={item.idCurso}
              style={{ width: "100%" }}
              header={
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  Módulo {i + 1}: {item.curso.nombre}
                  {estaRepetido && (
                    <>
                      <span className="icon-info" style={{ color: "yellow" }}>
                        <AiFillInfoCircle />
                      </span>
                      <Tooltip
                        target=".icon-info"
                        content="Este módulo ya lo llevaste anteriormente"
                        className="white-tooltip"
                        position="left"
                      />
                    </>
                  )}
                </div>
              }
            >
              <div className="contenedor_modulo">
                <div className="p-fluid formgrid grid">
                  <div className="field col-12 md:col-7">
                    <div className="border rounded-9 shadow p-md-4 mb-md-4 cardTabs" style={{ border: "#dee2e6 solid 1px" }}>
                      <div className="row g-2 mb-2 align-items-center" style={{ height: "100%" }}>
                        <div className="rounded-10 p-2 p-md-4 mb-md-4" style={{ marginTop: "10px" }}>
                          <div className="p-fluid formgrid grid">
                            {item.fechaVigenciaMembresia && new Date(item.fechaVigenciaMembresia) <= new Date() ? (
                              item.idCondicion ? (
                                item.idCondicion === 2 ? (
                                  <>
                                    <span className="subtitle fontsizeinitial h3">Promedio desaprobado: {item.promedio}</span>
                                    <span className="subtitle fontsizeinitial h3">No puedes descargar el certificado.</span>
                                  </>
                                ) : (
                                  <span className="subtitle fontsizeinitial h3">Promedio aprobado: {item.promedio}</span>
                                )
                              ) : (
                                <span className="subtitle fontsizeinitial h3" data-v-48f3e599="">
                                  El módulo "{item.curso.nombre}" ha expirado, tu membresia ha finalizado.
                                </span>
                              )
                            ) : item.idEstado === 3 ? (
                              <div className="field col-12 md:col-8 fontsizeinitial">
                                <div className="fontsizeinitialMargin">
                                  <span className="subtitulo_progreso fontsizeinitial h3" data-v-48f3e599="" style={{ color: "black" }}>
                                    Recuerda que...
                                  </span>
                                  <span className="subtitulo_progreso_description">
                                    Tienes 30 días para culminar el módulo desde que lo activas, una vez comenzado no podrás desactivarlo.
                                  </span>
                                </div>
                              </div>
                            ) : item.idEstado === 2 ? (
                              <div className="field col-12 md:col-8 fontsizeinitial">
                                <div className="fontsizeinitialMargin">
                                  <span className="subtitulo_progreso fontsizeinitial h3" data-v-48f3e599="" style={{ color: "black" }}>
                                    Progreso del módulo
                                  </span>
                                  {item.diasFaltantes > 0 ? (
                                    <>
                                      <span className="subtitulo_progreso_description">
                                        Has avanzado el <ProgresoProgramaCursoPormedio idCurso={item.idCurso} /> % del módulo
                                      </span>
                                      <span className="" style={{ fontSize: "11px" }}>| </span>
                                      <span
                                        style={{ color: diasVigencia <= 7 ? "red" : "inherit" }}
                                        className="avance_description_responsive"
                                      >
                                        Vence en {diasVigencia} días
                                      </span>
                                    </>
                                  ) : (
                                    <span className="subtitulo_progreso_description">
                                      El módulo ha terminado, puedes solicitar una única ampliación de 14 días.
                                    </span>
                                  )}
                                </div>
                              </div>
                            ) : item.idCondicion === 2 ? (
                              <div className="field col-12 md:col-8 fontsizeinitial">
                                <div className="fontsizeinitialMargin">
                                  <span className="subtitulo_progreso fontsizeinitial h3" data-v-48f3e599="" style={{ color: "black" }}>
                                    ¡Lo sentimos {perfil?.nombres}!
                                  </span>
                                  <span className="subtitulo_progreso_description">
                                    Desaprobaste el módulo {item.curso.nombre}, no podrás obtener tu certificado, sin embargo,
                                    si deseas continuar con tu desarrollo académico, puedes seguir revisando el curso.
                                  </span>
                                </div>
                              </div>
                            ) : item.idCondicion === 1 ? (
                              <div className="field col-12 md:col-8 fontsizeinitial">
                                <div className="fontsizeinitialMargin">
                                  <span className="subtitulo_progreso fontsizeinitial h3" data-v-48f3e599="" style={{ color: "black" }}>
                                    ¡Felicidades {perfil?.nombres || 'estimado alumno'}!
                                  </span>
                                  <span className="subtitulo_progreso_description">
                                    Culminaste satisfactoriamente tu módulo {item.curso.nombre}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div className="field col-12 md:col-8 fontsizeinitial">
                                <div className="fontsizeinitialMargin">
                                  <span className="subtitulo_progreso fontsizeinitial h3" data-v-48f3e599="" style={{ color: "black" }}>
                                    Recuerda que...
                                  </span>
                                  <span className="subtitulo_progreso_description">
                                    Tienes 30 días para culminar el módulo desde que lo activas, una vez comenzado no podrás desactivarlo.
                                  </span>
                                </div>
                              </div>
                            )}

                            <div style={{ marginTop: 10 }} className="field col-12 ml-4 md:col-4 progreso_barra_visibilidad">
                              <div className="progreso_barra">
                                <ProgresoProgramaCursoPormedioProgressBar idCurso={item.idCurso} Color="#6366F1" />
                              </div>
                            </div>

                            <div className="field col-12 md:col-4 xl:col-4">
                              {item.fechaVigenciaMembresia && new Date(item.fechaVigenciaMembresia) <= new Date() ? (
                                <div className="btn_progreso">
                                  <ButtonZegel
                                    label="¡Seguir aprendiendo!"
                                    color="primary"
                                    height="60px !important"
                                    onClick={() => handleLinkClickCursoBase(item.idPersonaCurso)}
                                  />
                                </div>
                              ) : item.diasFaltantes === "Expirado" && item.fechafin === null ? (
                                <>
                                  <div className="btn_progreso" style={{ marginBottom: "10px" }}>
                                    <ButtonZegel
                                      label="Solicitar ampliación"
                                      color="primary"
                                      onClick={() => {
                                        setShowAmpliacion(true);
                                        setIdPersonaCursoSolicitudAmpliacion(item.idPersonaCurso);
                                      }}
                                    />
                                  </div>
                                  <div className="btn_progreso">
                                    <ButtonZegel
                                      label="¡Seguir aprendiendo!"
                                      color="secondary"
                                      height="60px !important"
                                      onClick={() => handleLinkClickCursoBase(item.idPersonaCurso)}
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  {item.idEstado === 3 ? (
                                    <div className="btn_progreso">
                                      <ButtonZegel
                                        label="Activar módulo"
                                        color="primary"
                                        onClick={() => {
                                          setShowAlert(true);
                                          setContenidoAlertActivar(contenidoActivar);
                                          setcursoActivarSeleccion(i);
                                        }}
                                      />
                                    </div>
                                  ) : item.idEstado === 2 ? (
                                    <div className="btn_progreso">
                                      <ButtonZegel
                                        label="¡Seguir aprendiendo!"
                                        color="primary"
                                        height="60px !important"
                                        onClick={() => handleLinkClickCursoBase(item.idPersonaCurso)}
                                      />
                                    </div>
                                  ) : item.idEstado === 1 ? (
                                    <div className="divBottonAvance">
                                      <ButtonZegel
                                        label="Ver de nuevo"
                                        color="primary"
                                        onClick={() => navigate(`/${PrivateRoutes.HOME}/CursoInterno/${item.idPersonaCurso}`)}
                                      />
                                    </div>
                                  ) : (
                                    <div>
                                      <ButtonZegel
                                        label="Activar módulo"
                                        color="primary"
                                        onClick={() => {
                                          setShowAlert(true);
                                          setContenidoAlertActivar(contenidoActivar);
                                          setcursoActivarSeleccion(i);
                                        }}
                                      />
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>

                          <div
                            style={{
                              marginTop: item.idEstado === 3 ? 10 : item.idEstado === 2 ? 30 : 10,
                            }}
                            className="progresoModuloDesktop progreso_barra"
                          >
                            <ProgresoProgramaCursoPormedioProgressBar idCurso={item.idCurso} Color="#6366F1" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="field col-12 md:col-5">
                    {/* DESKTOP */}
                    <div className="p-fluid formgrid grid progreso-desktop-flex">
                      <div className="col-12 md:col-12" style={{ paddingBottom: "15px" }}>
                        <div className="p-fluid formgrid grid" style={{ paddingLeft: "6px" }}>
                          <div className="col-12 md:col-10" style={{ paddingRight: 0, border: "#dee2e6 solid 1px" }}>
                            <div className="rounded-9 shadow p-md-4 mb-md-4 cardTabsArchivosMaterialesPrograma">
                              <span className="subtitle text-sm h3" style={{ marginBottom: "7px", marginTop: "15px" }}>
                                Materiales del módulo
                              </span>
                            </div>
                          </div>
                          <div className="col-12 md:col-2" style={{ paddingLeft: 0 }}>
                            <div
                              className="flex align-items-center justify-content-center interna-material-download"
                              style={{ width: "77px", height: "100%" }}
                              onClick={() => handleDownloadMaterialesCurso(item.idCurso)}
                            >
                              {spinnerMateriales ? (
                                <ProgressSpinner style={{ width: "30px", height: "30px" }} />
                              ) : (
                                <img src={iconDownload} width="17.5px" height="21px" alt="Descargar materiales" />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 md:col-12">
                        <div className="p-fluid formgrid grid progreso-desktop-flex materiales" style={{ paddingLeft: "6px" }}>
                          <div className="col-6 p-0">
                            <div className="flex interna-material w-full-progreso-programa" style={{ paddingRight: 0, border: "#dee2e6 solid 1px" }}>
                              <div className="col-8 title-material-info mt-3">
                                <span className="subtitle text-sm" style={{ marginTop: "0.5rem" }}>
                                  <b className="card_download_title">Certificado del módulo</b>
                                </span>
                              </div>
                              <div className="col-4 p-0">
                                <div
                                  className={
                                    puedeDescargar
                                      ? "flex align-items-center justify-content-center interna-material-download"
                                      : "flex align-items-center justify-content-center interna-material-download-apagado botonescursos"
                                  }
                                  style={{ width: "77px", height: "100%" }}
                                  onClick={() => puedeDescargar && onDownloadCertificado(item)}
                                >
                                  <Tooltip
                                    target=".botonescursos"
                                    content={
                                      item.finCurso === null
                                        ? "Este botón se encuentra desactivado, dado que aún no terminas el módulo."
                                        : item.idCondicion === 2
                                        ? "Este botón se encuentra desactivado, dado que desaprobaste el módulo."
                                        : promedioNumerico < notaMinima
                                        ? `Este botón se encuentra desactivado, tu promedio es ${promedioNumerico} y necesitas al menos ${notaMinima} para aprobar.`
                                        : ""
                                    }
                                    className="white-tooltip"
                                    position="left"
                                  />
                                  {spinnerCertificado ? (
                                    <ProgressSpinner style={{ width: "30px", height: "30px" }} />
                                  ) : (
                                    <img src={iconDownload} width="17.5px" height="21px" alt="Descargar certificado" />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-6 p-0 pl-2">
                            <div className="flex interna-material w-full-progreso-programa" style={{ paddingRight: 0, border: "#dee2e6 solid 1px" }}>
                              <div className="col-8" style={{ marginTop: "1.5rem" }}>
                                <span className="subtitle text-sm" data-v-48f3e599="">
                                  <b className="card_download_title">Detalles de notas</b>
                                </span>
                              </div>
                              <div className="col-4 p-0">
                                <div
                                  className={
                                    item.idEstado === 1 &&
                                    isButtonDisabledNotas === false &&
                                    item.idCondicion !== 2 &&
                                    listaEvaluacionesUnidadeCursoPrograma
                                      ? "flex align-items-center justify-content-center interna-material-download"
                                      : "flex align-items-center justify-content-center interna-material-download-apagado botonescursos"
                                  }
                                  style={{ width: "77px", height: "100%" }}
                                  onClick={() => {
                                    if (item.idEstado === 1 && item.idCondicion !== 2 && listaEvaluacionesUnidadeCursoPrograma) {
                                      handleDownloadNotas(item.idCurso);
                                    }
                                  }}
                                >
                                  {spinnerNotas ? (
                                    <ProgressSpinner style={{ width: "30px", height: "30px" }} />
                                  ) : (
                                    <img src={iconDownload} width="17.5px" height="21px" alt="Descargar notas" />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* MOBILE */}
                    <div className="p-fluid formgrid grid mb-0 materiales_mobile">
                      <div className="border flex interna-material w-full mb-2">
                        <div className="interna-material-info card_download_title">
                          <span className="text-sm h3" data-v-48f3e599="">Materiales del módulo</span>
                        </div>
                        <div
                          className="flex align-items-center justify-content-center interna-material-download"
                          style={{ width: "77px", height: "100%" }}
                          onClick={() => handleDownloadMaterialesCurso(item.idCurso)}
                        >
                          {spinnerMateriales ? (
                            <ProgressSpinner style={{ width: "30px", height: "30px" }} />
                          ) : (
                            <img src={iconDownload} width="17.5px" height="21px" alt="Descargar materiales" />
                          )}
                        </div>
                      </div>

                      <div className="border flex interna-material w-full mb-2">
                        <div className="interna-material-info card_download_title">
                          <span className="text-sm h3" data-v-48f3e599="">Certificado del módulo</span>
                        </div>
                        <div
                          className={
                            puedeDescargar
                              ? "flex align-items-center justify-content-center interna-material-download"
                              : "flex align-items-center justify-content-center interna-material-download-apagado"
                          }
                          style={{ width: "77px", height: "100%" }}
                          onClick={() => puedeDescargar && onDownloadCertificado(item)}
                        >
                          {spinnerCertificado ? (
                            <ProgressSpinner style={{ width: "30px", height: "30px" }} />
                          ) : (
                            <img src={iconDownload} width="17.5px" height="21px" alt="Descargar certificado" />
                          )}
                        </div>
                      </div>

                      <div className="border flex interna-material w-full mb-2">
                        <div className="interna-material-info card_download_title">
                          <span className="text-sm h3" data-v-48f3e599="">Detalles de notas</span>
                        </div>
                        <div
                          className={
                            item.idEstado === 1 &&
                            isButtonDisabledNotas === false &&
                            item.idCondicion !== 2 &&
                            listaEvaluacionesUnidadeCursoPrograma
                              ? "flex align-items-center justify-content-center interna-material-download"
                              : "flex align-items-center justify-content-center interna-material-download-apagado"
                          }
                          style={{ width: "77px", height: "100%" }}
                          onClick={() => {
                            if (item.idEstado === 1 && item.idCondicion !== 2 && listaEvaluacionesUnidadeCursoPrograma) {
                              handleDownloadNotas(item.idCurso);
                            }
                          }}
                        >
                          {spinnerNotas ? (
                            <ProgressSpinner style={{ width: "30px", height: "30px" }} />
                          ) : (
                            <img src={iconDownload} width="17.5px" height="21px" alt="Descargar notas" />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="field col-12 md:col-7 mt-0">
                    <div className="border rounded-9 shadow p-3 p-md-4 mb-md-4 cardTabs card3Y4min-height" style={{ border: "#dee2e6 solid 1px" }}>
                      <div className="row g-2 mb-2 align-items-center">
                        <TabView className="tabviewProgreso" style={{ marginBottom: "10px" }} scrollable>
                          {listaUnidadeCursoPrograma
                            ?.filter(x => x.idCurso === item.idCurso)
                            .map((itemu, j) => (
                              <TabPanel key={j} header={`Unidad ${j + 1}`}>
                                <span className="leccion_header fontsizeunset h4" data-v-48f3e599="" style={{ marginTop: "0" }}>
                                  {itemu.descripcion}
                                </span>
                                <p
                                  className="fontsizeunset"
                                  dangerouslySetInnerHTML={{ __html: itemu.logro }}
                                  style={{ marginBottom: "20px" }}
                                />
                                <p><b className="fontsizeunset">Lecciones</b></p>
                                {listaLeccionUnidadeCursoPrograma
                                  ?.filter(x => x.idUnidad === itemu.idUnidad)
                                  .map((itemj, k) => (
                                    <div className="contenido-lecciones" key={k}>
                                      <span className="lecciones" style={{ color: "#010101" }}>
                                        {`- Lección ${k + 1}: `}
                                      </span>
                                      {item.idEstado !== 2 ? (
                                        <span className="fontsizeunset" style={{ color: "#7C7C7C" }}>
                                          {itemj.descripcion}
                                        </span>
                                      ) : (
                                        <Link
                                          style={{ color: "blue" }}
                                          to={`/${PrivateRoutes.HOME}/CursoInterno/${item.idPersonaCurso}/${itemu.idUnidad}/${itemj.idLeccion}`}
                                        >
                                          {itemj.descripcion}
                                        </Link>
                                      )}
                                    </div>
                                  ))}
                              </TabPanel>
                            ))}
                        </TabView>
                      </div>
                    </div>
                  </div>

                  <div className="field col-12 md:col-5 progreso-desktop-block">
                    <div className="border rounded-9 shadow p-md-4 mb-md-4 cardTabs card3Y4min-height card_contenedor_avance_desktop" style={{ border: "#dee2e6 solid 1px" }}>
                      <span className="subtitle h4 pb-3" data-v-48f3e599="">Avance de unidades</span>
                      <div style={{ marginLeft: "10px" }}>
                        {listaUnidadeCursoPrograma
                          ?.filter(x => x.idCurso === item.idCurso)
                          .map((itemu, j) => (
                            <div className="p-fluid formgrid grid" key={j}>
                              <div className="field col-12 md:col-2" style={{ paddingLeft: "0", paddingRight: "0" }}>
                                <b className="fontsizesmall">{`Unidad ${j + 1}`}</b>
                              </div>
                              <div className="field col-12 md:col-5 bar-progress-unidades">
                                <ProgresoProgramaCursoUnidadPormedioProgressBar idCurso={item.idCurso} idUnidad={itemu.idUnidad} />
                              </div>
                              <div className="field col-12 md:col-1">
                                <ProgresoProgramaCursoUnidadPormedio idCurso={item.idCurso} idUnidad={itemu.idUnidad} />
                              </div>
                              <div className="field col-12 md:col-4" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <UnidadEvaluacion idCurso={item.idCurso} idUnidad={itemu.idUnidad} />
                              </div>
                            </div>
                          ))}
                      </div>
                      <span className="subtitle h4" data-v-48f3e599="">
                        <VistaPromedio promedio={item.promedio || "0"} />
                      </span>
                    </div>
                  </div>

                  <div className="field col-12 md:col-5 progreso-mobile">
                    <div className="border rounded-9 shadow p-3 p-md-4 mb-md-4 cardTabs">
                      <span className="title_avance_unidades" data-v-48f3e599="">Avance de unidades</span>
                      {listaUnidadeCursoPrograma
                        ?.filter(x => x.idCurso === item.idCurso)
                        .map((itemu, j) => (
                          <Avance
                            key={j}
                            itemu={itemu}
                            item={item}
                            i={j}
                            listaProgresoLeccionUnidadeCursoPrograma={listaProgresoLeccionUnidadeCursoPrograma}
                            listaLeccionUnidadeCursoPrograma={listaLeccionUnidadeCursoPrograma}
                            listaEvaluacionesUnidadeCursoPrograma={listaEvaluacionesUnidadeCursoPrograma}
                          />
                        ))}
                      <span className="subtitle h4" data-v-48f3e599="">
                        <span>{calcularPromedioNotasPorUnidad(item.idCurso)}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </AccordionTab>
          );
        })}
      </Accordion>

      {/* DIÁLOGOS */}
      <DialogZegel
        header=""
        visible={showAlert}
        width="30vw"
        onHide={() => setShowAlert(false)}
        footer={footerActivar}
        contenido={contenidoAlertActivar}
      />
      <DialogZegel
        header=""
        visible={showAmpliacion}
        width="30vw"
        onHide={() => setShowAmpliacion(false)}
        footer={footerAmpliacion}
        contenido={contenidoAmpliacion}
      />
      <DialogZegel
        header=""
        visible={showErrorMateriales}
        width="30vw"
        onHide={() => setShowErrorMateriales(false)}
        footer={footerErrorMateriales}
        contenido={contenidoErrorMateriales}
      />
    </div>
  );
}

export default ModulosAcordionProgramaComponent;